import React from "react";
import { useIsSmallScreenSize } from "../../theme/styled";
import { Drawer, type DrawerProps } from "./atoms/Drawer";
import type { PopperProps } from "./atoms/Popper";
import { Popper } from "./atoms/Popper";

export interface PopoverProps
  extends Omit<PopperProps & DrawerProps, "popoverRef"> {
  drawerOnSmallScreenSize: boolean;
  role?: "dialog" | "menu";
}

/**
 * A hovering element containing actionable content.
 * Uses Popper and Drawer components under the hood.
 */
export function Popover({
  onClose,
  isOpen,
  dataTestId,
  ariaLabel,
  children,
  drawerOnSmallScreenSize,
  anchorRef,
  offsetMainAxis,
  offsetCrossAxis,
  placement,
  closeOnTab = true,
  style,
  role = "dialog",
}: PopoverProps): React.JSX.Element {
  const isSmallScreenSize = useIsSmallScreenSize();

  const Component = isSmallScreenSize && drawerOnSmallScreenSize
    ? Drawer
    : Popper;

  return (
    <Component
      dataTestId={dataTestId}
      isOpen={isOpen}
      onClose={onClose}
      anchorRef={anchorRef}
      ariaLabel={ariaLabel}
      offsetMainAxis={offsetMainAxis}
      offsetCrossAxis={offsetCrossAxis ?? 0}
      placement={placement}
      closeOnTab={closeOnTab}
      style={style}
      role={role}
    >
      {children}
    </Component>
  );
}
